module.exports = __webpack_public_path__ + "static/example-banner-3023c455394bb04dc39cd72606b5531d.jpg";